import { Customer, SearchParams } from '../types';
import { apiClient } from '../services/api';
import { usePaginatedQuery } from './usePaginatedQuery';

const fetchCustomersPage = (params: SearchParams) => apiClient.getCustomersPaginated(params);

/**
 * Owns the server state for the paginated customer list.
 * A request id prevents a slower response from an older query replacing a
 * newer page or search result.
 */
export const useCustomers = (params: SearchParams) => usePaginatedQuery<Customer, SearchParams>(
  params,
  fetchCustomersPage,
  'Failed to load customers',
  'name',
  true,
  'customers',
);
